import { DateTime } from 'luxon';

export default () => {
    let id;
    let locale;
    let index;
    let width;
    let height;
    let startedAt;
    let metrics;
    let videoActions;

    const startMetric = (newId, newLocale, newIndex = 0) => {
        id = newId;
        locale = newLocale;
        index = newIndex;
        width = window.screen.width;
        height = window.screen.height;
        startedAt = DateTime.now();
        metrics = [];
        videoActions = [];
    };

    const sendMetric = (newLocale, newIndex) => {
        if (!startedAt) {
            return;
        }

        if (!metrics.length) {
            return;
        }

        axios.post(route('reader_metric', [locale, id]), {
            index,
            width,
            height,
            metrics,
            videoActions,
            seconds: DateTime.now().diff(startedAt).as('seconds')
        });

        startMetric(id, newLocale, newIndex);
    };

    const addMetric = action => {
        if (!startedAt) {
            return;
        }

        metrics.push({
            action,
            seconds: DateTime.now().diff(startedAt).as('seconds')
        });

        if (metrics.length === 5) {
            sendMetric(locale, index);
        }
    };

    const addVideoAction = name => {
        if (!startedAt) {
            return;
        }

        videoActions.push({
            name
        });
    };

    return {
        startMetric,
        sendMetric,
        addMetric,
        addVideoAction
    };
};
